var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "surface1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.64,
    height: 14.666,
    viewBox: "0 0 9.64 14.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M9.64,8.277,4.82,10.063,0,8.277,4.82,0Zm0,0",
    fill: "#8a92b2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M16.571,323.7l-4.61,5.394L7.352,323.7l4.61,1.707Zm0,0",
    transform: "translate(-7.141 -314.427)",
    fill: "#8a92b2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M168.281,325.406l4.61-1.707-4.61,5.394Zm0,0",
    transform: "translate(-163.461 -314.427)",
    fill: "#474c77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M173.1,8.277l-4.82,1.785V0Zm0,0",
    transform: "translate(-163.461)",
    fill: "#474c77"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/Ethereum.d00216179f3b722913b0a63f0f568946.svg";
export { ForwardRef as ReactComponent };